<template>
  <div class="main-wrapper" v-loading="loading" :element-loading-text="loadingText">
    <div class="header-wrapper">
      <h3 class="title">微信智能小海</h3>
    </div>
    <div v-if="ifLogin === false && loading === false">
      <div>
        <span>状态：未登录</span>
        <el-button @click="robotLogin" type="text">获取登录二维码</el-button>
      </div>
      <div class="qrcode-wrapper" v-if="showQrcode">
        <img class="qrcode" :src="qrcodeImage">
        <div>使用微信扫描上方二维码（长按识别无效），登录微信智能小海。</div>
      </div>
    </div>
    <div v-else-if="ifLogin === true">
      <div>
        <span>用户名：{{robotInfo.user.NickName}}</span><br>
        <span>状态：已登录</span>
        <el-button @click="robotLogout" type="text">下线</el-button>
      </div>
      <el-tabs v-model="activeTab">
        <el-tab-pane label="微信群管理" name="wechatGroupTab">
          <el-button type="primary" @click="loadWechatGroup" style="margin-bottom: 10px;">刷新微信群</el-button>
          <el-table :data="wechatGroups" stripe border style="width: 100%" v-loading="wechatLoading" element-loading-text="正在加载数据">
            <el-table-column align="center" prop="id" label="ID"></el-table-column>
            <el-table-column align="center" prop="name" label="群名称" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="desc" label="群描述" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="notice" label="群公告" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="visible" label="显示到群导航" :formatter="wechatGroupVisibleFormatter"></el-table-column>
            <el-table-column align="center" label="激活状态">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.active === 1">激活</el-tag>
                <el-tag type="danger" v-else-if="scope.row.active === 0">禁用</el-tag>
                <el-tag type="gray" v-else>未知</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button size="small" type="primary" @click="showUpdateWechatGroupDialog(scope.row)">更新</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="自动回复设置" name="autoReplyTab">
          <el-button type="primary" @click="showAddAutoReplyDialog" style="margin-bottom: 10px;">添加自动回复</el-button>
          <el-table :data="autoReplys" stripe border style="width: 100%">
            <el-table-column align="center" prop="id" label="ID"></el-table-column>
            <el-table-column align="center" prop="keyword" label="关键字"></el-table-column>
            <el-table-column align="center" prop="reply_type" label="回复类型" :formatter="autoReplyReplyTypeFormatter"></el-table-column>
            <!--<el-table-column align="center" prop="reply" label="回复"></el-table-column>-->
            <el-table-column align="center" prop="match" label="匹配方式" :formatter="autoReplyMatchFormatter"></el-table-column>
            <el-table-column align="center" label="激活状态">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.active === 1">激活</el-tag>
                <el-tag type="danger" v-else-if="scope.row.active === 0">禁用</el-tag>
                <el-tag type="gray" v-else>未知</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="scope" label="适用范围" :formatter="autoReplyScopeFormatter"></el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-button size="small" type="primary" @click="showUpdateAutoReplyDialog(scope.row)">更新</el-button>
                <el-button size="small" type="danger" @click="showDeleteAutoReplyDialog(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog title="更新微信群" :visible.sync="updateWechatGroupDialogVisible">
      <el-form ref="autoReplyForm" :model="wechatGroupForm" label-width="80px">
        <el-form-item label="群名称">
          <el-input v-model="wechatGroupForm.name"></el-input>
        </el-form-item>
        <el-form-item label="群描述">
          <el-input v-model="wechatGroupForm.desc" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="群公告">
          <el-input v-model="wechatGroupForm.notice" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="显示到群导航">
          <el-radio v-model="wechatGroupForm.visible" :label="1">显示</el-radio>
          <el-radio v-model="wechatGroupForm.visible" :label="0">不显示</el-radio>
        </el-form-item>
        <el-form-item label="激活状态">
          <el-radio v-model="wechatGroupForm.active" :label="1">激活</el-radio>
          <el-radio v-model="wechatGroupForm.active" :label="0">禁用</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="updateWechatGroupDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateWechatGroup">更 新</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="autoReplyDialogTitle" :visible.sync="autoReplyDialogVisible" @close="closeAutoReplyDialog">
      <el-form ref="autoReplyForm" :model="autoReplyForm" label-width="80px">
        <el-form-item label="关键字">
          <el-input v-model="autoReplyForm.keyword"></el-input>
        </el-form-item>
        <el-form-item label="回复类型">
          <el-radio-group v-model="autoReplyForm.reply_type">
            <el-radio :label="1">文字</el-radio>
            <el-radio :label="2">链接</el-radio>
            <el-radio :label="3">图片</el-radio>
            <el-radio :label="4">视频</el-radio>
            <el-radio :label="5">小程序</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="回复内容" v-if="autoReplyForm.reply_type === 1 || autoReplyForm.reply_type === 2">
          <el-input v-model="autoReplyForm.reply" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="视频/图片URL" v-if="autoReplyForm.reply_type === 3 || autoReplyForm.reply_type === 4">
          <el-input v-model="autoReplyForm.media_url" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="小程序标题" v-if="autoReplyForm.reply_type === 5">
          <el-input v-model="autoReplyForm.share_title" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="小程序路径" v-if="autoReplyForm.reply_type === 5">
          <el-input v-model="autoReplyForm.share_path" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="小程序描述" v-if="autoReplyForm.reply_type === 5">
          <el-input v-model="autoReplyForm.share_desc" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="小程序缩略图" v-if="autoReplyForm.reply_type === 5">
          <el-input v-model="autoReplyForm.share_thumb_url" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="匹配方式">
          <el-radio v-model="autoReplyForm.match" :label="1">全字匹配</el-radio>
          <el-radio v-model="autoReplyForm.match" :label="0">包含匹配</el-radio>
        </el-form-item>
        <el-form-item label="激活状态">
          <el-radio v-model="autoReplyForm.active" :label="1">激活</el-radio>
          <el-radio v-model="autoReplyForm.active" :label="0">禁用</el-radio>
        </el-form-item>
        <el-form-item label="适用范围">
          <el-radio v-model="autoReplyForm.scope" :label="1">仅用户</el-radio>
          <el-radio v-model="autoReplyForm.scope" :label="2">仅群</el-radio>
          <el-radio v-model="autoReplyForm.scope" :label="3">全部适用</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="closeAutoReplyDialog">取 消</el-button>
        <el-button v-if="autoReplyDialogMode === 'add'" type="primary" @click="addAutoReply">添 加</el-button>
        <el-button v-if="autoReplyDialogMode === 'update'" type="primary" @click="updateAutoReply">更 新</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        ifLogin: false,
        loading: false,
        loadingText: null,
        wechatLoading: false,
        shopId: null,
        showQrcode: false,
        qrcodeImage: null,
        robotInfo: null,
        wechatGroups: [],
        unActiveWechatGroups: [],
        autoReplys: [],
        timer: null,
        activeTab: 'wechatGroupTab',
        updateWechatGroupDialogVisible: false,
        autoReplyDialogVisible: false,
        autoReplyDialogTitle: null,
        autoReplyDialogMode: 'add',
        selectedWechatGroupId: null,
        autoReplyForm: {},
        wechatGroupForm: {}
      }
    },
    watch: {
      '$route' (to, from) {
        this.init()
      },
      'timer' (newTimer, oldTimer) {
        if (oldTimer) {
          clearInterval(oldTimer)
        }
      }
    },
    mounted () {
      this.init()
    },
    destroyed () {
      this.clearTimer()
    },
    methods: {
      init () {
        this.shopId = this.$route.params.sid
        this.loading = true
        this.ifLogin = false
        this.loadingText = '检测登录状态'
        this.clearTimer()
        this.$store.dispatch('robot/checkRobotLoginStatus', this.shopId).then(res => {
          if (res.errcode === 0 && res.logged_in === true) {
            this.loading = false
            this.ifLogin = true
            this.showQrcode = false
            this.robotInfo = res
            this.loadWechatGroup()
            this.getAutoReply()
          } else if (res.errcode === 404) {
            this.$store.dispatch('robot/robotLogin', this.shopId).then(res => {
              this.loading = false
            })
          } else {
            this.loading = false
          }
        })
      },
      robotLogin () {
        // 机器人登录
        this.loading = true
        this.loadingText = '获取登录二维码'
        this.clearTimer()
        this.$store.dispatch('robot/robotLogin', this.shopId).then(res => {
          if (res.errcode === 0) {
            setTimeout(() => {
              this.getQrcode()
            }, 2000)
          } else {
            this.loading = false
          }
        })
      },
      getQrcode () {
        // 获取机器人登录二维码
        this.$store.dispatch('robot/getRobotLoginQrcode', this.shopId).then(res => {
          this.qrcodeImage = 'data:image/jpeg;base64,' + res
          this.loading = false
          this.showQrcode = true
          this.checkIfLogin()
        })
      },
      robotLogout () {
        // 机器人下线
        this.loading = true
        this.loadingText = '下线'
        this.$store.dispatch('robot/robotLogout', this.shopId).then(res => {
          this.ifLogin = false
          this.loading = false
          this.showQrcode = false
        })
      },
      checkIfLogin () {
        // 检测机器人是否登录
        this.$store.dispatch('robot/checkRobotLoginStatus', this.shopId).then(res => {
          if (res.errcode === 0 && res.logged_in === true) {
            this.clearTimer()
            if (this.ifLogin === false) {
              // 获取机器人信息
              this.$store.dispatch('robot/getRobotInfo', this.shopId).then(res => {
                // 登录
                this.robotInfo = res
                this.ifLogin = true
                this.loadWechatGroup()
                this.getAutoReply()
              })
            }
          } else {
            this.timer = setInterval(() => {
              this.checkIfLogin()
            }, 2000)
          }
        })
      },
      loadWechatGroup () {
        // 加载微信群信息
        this.wechatLoading = true
        this.$store.dispatch('robot/loadWechatGroup', this.shopId).then(res => {
          if (res.errcode === 0) {
            this.getActiveWechatGroup()
          } else {
            this.wechatLoading = false
          }
        })
      },
      getActiveWechatGroup () {
        // 获取已激活机器人的微信群
        this.getWechatGroup(1).then(res => {
          this.wechatGroups = res
          this.wechatLoading = false
        })
      },
      getWechatGroup (active) {
        // 获取微信群信息
        return this.$store.dispatch('robot/getWechatGroupList', {shopId: this.shopId})
      },
      updateWechatGroup () {
        // 更新微信群
        let data = Object.assign({groupId: this.wechatGroupForm.id}, this.wechatGroupForm)
        this.$store.dispatch('robot/updateWechatGroup', data).then(res => {
          if (res.errcode === 0) {
            this.getActiveWechatGroup()
            this.updateWechatGroupDialogVisible = false
          }
        })
      },
      showUpdateWechatGroupDialog (wechatGroup) {
        // 显示更新微信群对话框
        this.updateWechatGroupDialogVisible = true
        this.wechatGroupForm = Object.assign({}, wechatGroup)
      },
      showAddAutoReplyDialog () {
        // 显示添加自动回复对话框
        this.autoReplyDialogMode = 'add'
        this.autoReplyDialogTitle = '添加自动回复'
        this.autoReplyForm = {
          keyword: null,
          reply_type: 1,
          reply: null,
          media_url: null,
          share_title: null,
          share_path: null,
          share_desc: null,
          share_thumb_url: null,
          match: 1,
          active: 1,
          scope: 3
        }
        this.autoReplyDialogVisible = true
      },
      showUpdateAutoReplyDialog (autoReply) {
        // 显示更新自动回复对话框
        this.autoReplyDialogMode = 'update'
        this.autoReplyDialogTitle = '更新自动回复'
        this.autoReplyForm = Object.assign({}, autoReply)
        this.autoReplyDialogVisible = true
      },
      closeAutoReplyDialog () {
        // 关闭自动回复对话框
        this.autoReplyDialogVisible = false
        this.autoReplyForm = {}
      },
      showDeleteAutoReplyDialog (autoReplyId) {
        // 显示自动回复对话框
        this.$confirm('此操作将永久删除该自动回复, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'danger'
        }).then(() => {
          this.$store.dispatch('robot/deleteAutoReply', autoReplyId).then((res) => {
            if (res.errcode === 0) {
              this.$message('已成功删除自动回复')
              this.getAutoReply()
            }
          })
        }).catch(() => {})
      },
      addAutoReply () {
        // 添加自动回复
        this.autoReplyDialogMode = 'add'
        this.autoReplyDialogTitle = '添加自动回复'
        let data = Object.assign({shop_id: this.shopId}, this.autoReplyForm)
        this.$store.dispatch('robot/addAutoReply', data).then(res => {
          this.getAutoReply()
          this.autoReplyDialogVisible = false
        })
      },
      updateAutoReply () {
        // 更新自动回复
        let data = {
          id: this.autoReplyForm.id,
          keyword: this.autoReplyForm.keyword,
          reply_type: this.autoReplyForm.reply_type,
          match: this.autoReplyForm.match,
          active: this.autoReplyForm.active,
          scope: this.autoReplyForm.scope,
          reply: '',
          media_url: '',
          share_title: '',
          share_path: '',
          share_desc: '',
          share_thumb_url: ''
        }
        if (data.reply_type === 1 || data.reply_type === 2) {
          data.reply = this.autoReplyForm.reply
        } else if (data.reply_type === 3 || data.reply_type === 4) {
          data.media_url = this.autoReplyForm.media_url
        } else if (data.reply_type === 5) {
          data.share_title = this.autoReplyForm.share_title
          data.share_path = this.autoReplyForm.share_path
          data.share_desc = this.autoReplyForm.share_desc
          data.share_thumb_url = this.autoReplyForm.share_thumb_url
        }
        this.$store.dispatch('robot/updateAutoReply', data).then(res => {
          this.getAutoReply()
          this.autoReplyDialogVisible = false
        })
      },
      getAutoReply () {
        // 获取机器人所有的自动回复
        this.$store.dispatch('robot/getAutpReplys', this.shopId).then(res => {
          this.autoReplys = res
        })
      },
      clearTimer () {
        if (this.timer) {
          clearInterval(this.timer)
        }
        this.timer = null
      },
      wechatGroupVisibleFormatter (row, column) {
        let visible = row.visible
        if (visible === 1) {
          return '显示'
        } else if (visible === 0) {
          return '不显示'
        }
        return '未知'
      },
      wechatGroupActiveFormatter (row, column) {
        let active = row.active
        if (active === 1) {
          return '激活'
        } else if (active === 0) {
          return '禁用'
        }
        return '未知'
      },
      autoReplyReplyTypeFormatter (row, column) {
        let ret = null
        switch (row.reply_type) {
          case 1:
            ret = '文字'
            break
          case 2:
            ret = '链接'
            break
          case 3:
            ret = '图片'
            break
          case 4:
            ret = '视频'
            break
          case 5:
            ret = '小程序'
            break
          default:
            ret = '未知'
        }
        return ret
      },
      autoReplyMatchFormatter (row, column) {
        let match = row.match
        if (match === 1) {
          return '全字匹配'
        } else if (match === 0) {
          return '包含匹配'
        }
        return '未知'
      },
      autoReplyActiveFormatter (row, column) {
        let active = row.active
        if (active === 1) {
          return '激活'
        } else if (active === 0) {
          return '禁用'
        }
        return '未知'
      },
      autoReplyScopeFormatter (row, column) {
        let scope = row.scope
        if (scope === 1) {
          return '仅用户'
        } else if (scope === 2) {
          return '仅群'
        } else if (scope === 3) {
          return '全部适用'
        }
        return '未知'
      }
    }
  }
</script>

<style lang="sass">
  .main-wrapper
    padding: 20px
    .header-wrapper
      overflow: hidden
      margin-bottom: 10px
      .title
        font-size: 14px
        line-height: 2
        font-weight: 600
        float: left
    .qrcode-wrapper
      text-align: center
      min-height: 200px
      .qrcode
        width: 200px
</style>



// WEBPACK FOOTER //
// index.vue?64a0c102